import { NgModule } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { SharedModule } from './../../shared/modules/shared.module';

import { CheckoutComponent } from './checkout.component';
import { ConfirmationComponent } from './confirmation/confirmation.component';
import { ProductListComponent } from './shared/product-list/product-list.component';
import { ProductRowComponent } from './shared/product-list/product-row/product-row.component';
//import { RenewalComponent } from './renewal/renewal.component';
//import { ProductsComponent } from './products/products.component';
import { ExamComponent } from './exam/exam.component';
//import { RenewalPaymentComponent } from './renewal/renewal-payment/renewal-payment.component';
//import { ProductsPaymentComponent } from './products/products-payment/products-payment.component';
import { RequiredIfNotDirective } from './../../shared/directives/required-if-not.directive';
import { CertificationComponent } from './certification/certification.component';
import { ProductsRenewalComponent } from './products-renewal/products-renewal.component';
import { ProductRenewalPaymentComponent } from './products-renewal/product-renewal-payment/product-renewal-payment.component';
import { MomentModule } from 'ngx-moment';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    NgxMaskDirective,
    SharedModule,
    MomentModule
  ],
  declarations: [
    CheckoutComponent,
    ConfirmationComponent,
    ProductListComponent,
    ProductRowComponent,
    //RenewalComponent,
    //ProductsComponent,
    ExamComponent,
    //RenewalPaymentComponent,
    //ProductsPaymentComponent,
    RequiredIfNotDirective,
    CertificationComponent,
    ProductsRenewalComponent,
    ProductRenewalPaymentComponent
  ],
  providers: [DecimalPipe, provideNgxMask()]
})
export class CheckoutModule { }
